import React, { useState } from "react";
import { connect } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import { roundOfDays, Unit } from "../../../helpers/unit";
import CrewForm from "../Crew/CrewForm";
import { isToday, usePermission } from "../../../helpers/common";
import { SubNav } from "../../layout/submenu";

const ColumnHeader = props => {
    const { isRequesting, isChanged, crewId, crew, settings, search } = props;
    if (!crew) return <></>;

    const unit = Unit.getInstance();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const allow = usePermission();

    return <>
        <div className="kanban-column-header">
            <Card>
                <Card.Header className="d-flex flex-column">
                    {crew.is_end_crew && <div><i className="fa fa-ban icon-end" aria-hidden="true"></i></div>}
                    <Row>
                        <Col className="col-10">
                            <Card.Title as="div" className={`${crew.is_end_crew && `text-end`}`}>
                                <div>{crew.crew_name}{isChanged && <sup className="super-set">*</sup>}</div>
                            </Card.Title>
                        </Col>
                        <Col className="col-2">
                            {isToday(search.range) && !isRequesting && allow("crew", "edit") && <div><i className="fa fa-pencil card-edit" title="edit" onClick={handleShow} /></div>}
                        </Col>
                    </Row>
                    <Row className="workplan-daterange" >
                        {crew.is_work_plan
                            ? <SubNav.DateRange
                                start={crew.plan_start_date}
                                end={crew.plan_end_date && !isChanged ? crew.plan_end_date : null}
                                isCrewworkPlan={true}
                            />
                            : isRequesting ? "Loading..." : "No workplan"}
                    </Row>
                </Card.Header>
                {crew.is_work_plan && <Card.Body>
                    {isRequesting && <Row><Col className="text-center">Loading...</Col></Row>}
                    {!isRequesting && crew.hasOwnProperty("total_working_days") && <> <Row>
                        <Col lg={4} md={4} sm={4} className="summary-cell">
                            <div className="summary-num">{roundOfDays(crew.total_working_days)}</div>
                            <h6 className="summary-title">Working Days</h6>
                        </Col>
                        <Col lg={4} md={4} sm={4} className="summary-cell">
                            <div className="summary-num">{unit.toRoundOfArea(crew.acres_per_day)}</div>
                            <h6 className="summary-title">{settings.areaShortName}/Day</h6>
                        </Col>
                        <Col lg={4} md={4} sm={4} className="summary-cell">
                            <div className="summary-num">{unit.toRoundOfArea(crew.acres_per_hour)}</div>
                            <h6 className="summary-title">{settings.areaShortName}/Hour</h6>
                        </Col>
                    </Row>
                    </>}
                </Card.Body>}
            </Card>
        </div>
        <CrewForm show={show} onHide={handleClose} crewId={crewId} />
    </>;
};

const mapStateToProps = (state, ownProps) => {
    const crew = state.crewKanban.crews[ownProps.crewId] ? state.crewKanban.crews[ownProps.crewId] : null;
    return {
        isRequesting: crew ? crew.isRequesting : false,
        crew: crew ? crew.info : null,
        isChanged: crew ? crew.isChanged : false,
        settings: { areaShortName: state.user.settings.areaShortName },
        search: { range: state.analyze.searchParams.range }
    };
};

export default connect(mapStateToProps)(ColumnHeader);